import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import PlanYourGathering from "./sections/PlanYourGathering";
import OurLocation from "./sections/OurLocation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <PlanYourGathering />
      <OurLocation />
      <Footer />
    </div>;
}